import { render, staticRenderFns } from "./FileUploadAccess.vue?vue&type=template&id=76ddbc1a&scoped=true&"
import script from "./FileUploadAccess.vue?vue&type=script&lang=js&"
export * from "./FileUploadAccess.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadAccess.vue?vue&type=style&index=0&id=76ddbc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ddbc1a",
  null
  
)

export default component.exports